<template>
  <v-container :class="$vuetify.breakpoint.width < 550 ? 'maklerteam-xs' : 'maklerteam'"
               class="pa-0"
               fluid>

    <div class="semanticsection-title2 primary--text">{{ teamInfo.sectionTitle }}
    </div>

    <v-row no-gutters>

      <v-col v-for="(person, index) in teamInfo.persons"
           :key="`makler-${index}`"
           :class="{'col-12': $vuetify.breakpoint.width < 912}"
           class="single-profile-line">

        <img :src="getImgUrl(person.imgSrc)"
             :class="person.cssClass ? person.cssClass : 'profile--img'">

        <div class="profile--text">
          <span> {{ person.name }}</span>
          <div v-html="person.rolle" />
          <div v-if="showContact(person)"
               class="maklerteam-contact">
            <div v-if="person.phone">
              <a :href="'tel:' + person.phoneClickable">
                <!--  <v-icon>phone</v-icon> --> <img src="../../assets/svg/ic_telefon_xsmall.svg"
                                                      height="20px"
                                                      style="margin: 0 4px 0 -24px; vertical-align: middle;">
                {{ person.phone }}
              </a>
            </div>
            <div v-if="person.fax">
              <img src="../../assets/svg/ic_fax.svg"
                   height="20px"
                   style="margin: 0 4px 0 -24px; vertical-align: middle;">
              {{ person.fax }}
            </div>
            <div v-if="person.email">
              <!--  <v-icon>email</v-icon> -->
              <a :href="`mailto:${person.email}`">
                <img src="../../assets/svg/ic_mail_xsmall.svg"
                     height="20px"
                     style="margin: 0 4px 0 -24px; vertical-align: middle;">
                {{ person.email }}
              </a>
            </div>
            <div v-if="person.termin">
              <a :href="person.termin" target="_blank">
                <img src="../../assets/svg/ic_cal_xsmall.svg"
                     height="20px"
                     style="margin: 0 4px 0 -24px; vertical-align: middle;">
                Persönliche Sprechstunde per Video-Call buchen
              </a>
            </div>
          </div>
        </div>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MaklerTeamBlock",
  props: {
    teamInfo: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      imgCache: {}
    };
  },
  methods: {
    getImgUrl(imgSrc) {
      return imgSrc && (imgSrc.indexOf('.') > 0) ? 'images/team' + imgSrc : 'images/team/placeholder3.jpg';
    },
    showContact(person) {
      return person.phone || person.fax || person.email;
    }
  }
};
</script>

<style>
.maklerteam {
  width: 100%;
  margin-bottom: -32px;
}

.maklerteam-xs {
  width: 100%;
  margin-bottom: -32px;
}

.maklerteam > .row {
  margin-left: 48px!important;
  display: flex;
  justify-content: space-between;
}

.maklerteam-xs > .row {
  margin-left: 0;
  display: flex;
  justify-content: space-between;
}

.maklerteam .single-profile-line {
  display: flex;
  margin-bottom: 32px;
  width: 354px;
  min-width: 354px;
  max-width: 354px;
}
.makler-regional-container .maklerteam .single-profile-line {
  display: flex;
  margin-bottom: 32px;
  width: 484px;
  min-width: 484px;
  max-width: 484px;
}

.maklerteam-xs .single-profile-line {
  display: flex;
  margin-bottom: 32px;
  width: 354px;
  min-width: 354px;
}

.profile--text {
  margin-left: 24px;
  font-size: 14px;
  white-space: pre-line;
  position: relative;
}

.profile--text span {
  font-size: 20px;
}

.profile--img {
  height: 201px;
  width: 134px;
  min-height: 201px;
  min-width: 134px;
  padding-top: 4px;
}

.profile--img--vertrieb {
  height: 160px;
  width: 134px;
  min-height: 160px;
  min-width: 134px;
  padding-top: 4px;
}

.maklerteam-contact {
  padding-top: 20px;
  line-height: 27px;
}

.maklerteam-contact > div {
  position: relative;
  padding-left: 24px;
  white-space: nowrap;
}

.maklerteam-contact > div i {
  position: absolute;
  top: 4px;
  left: 0;
  font-size: 14pt;
  height: 20px;
}

.maklerteam-contact a {
  color: rgba(0, 0, 0, .87)!important;
}

</style>
